import { render, staticRenderFns } from "./copy-text.vue?vue&type=template&id=ece6e10a&scoped=true&"
import script from "./copy-text.vue?vue&type=script&lang=js&"
export * from "./copy-text.vue?vue&type=script&lang=js&"
import style0 from "./copy-text.vue?vue&type=style&index=0&id=ece6e10a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece6e10a",
  null
  
)

export default component.exports